import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { DagSourceModel } from "@app/workflow-common/services/DagSourceModel";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { PutJobOnHoldBlockModel } from "@app/workflow-common/services/models/PutJobOnHoldBlockModel";
import { CommonService } from "@app/services";
var PutJobHoldWidgetComponent = /** @class */ (function () {
    function PutJobHoldWidgetComponent(formBuilder, commonService) {
        this.formBuilder = formBuilder;
        this.commonService = commonService;
        this.isConditional = false;
        this.conditionalColName = '';
        this.close = new EventEmitter();
        this.inputModel = undefined;
        this.changeStageBlockData = {};
        this.selectedJobDescriptionInputs = {};
        this.isLoading = false;
        this.isFormSubmitted = false;
    }
    PutJobHoldWidgetComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var blockObject, modelData, formGroupConfig;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.changeStageBlockData = this.dagSourceModel.getBlocksSource().getBlockByKey(this.blockObject.key);
                        blockObject = tslib_1.__assign({}, this.blockObject);
                        modelData = blockObject['model'] ? blockObject['model'] : undefined;
                        this.inputModel = new PutJobOnHoldBlockModel(modelData);
                        this.makePutOnHoldDropdownData();
                        return [4 /*yield*/, this.resolveData()];
                    case 1:
                        _a.sent();
                        formGroupConfig = {
                            reasonId: new FormControl(this.inputModel.reasonId, [Validators.required]),
                            reasonDisplayName: new FormControl(this.inputModel.reasonDisplayName)
                        };
                        if (this.isConditional) {
                            formGroupConfig['condition'] = this.formBuilder.group({});
                        }
                        this.form = this.formBuilder.group(formGroupConfig);
                        return [2 /*return*/];
                }
            });
        });
    };
    PutJobHoldWidgetComponent.prototype.makePutOnHoldDropdownData = function () {
        this.selectedJobDescriptionInputs['reasonId'] = this.inputModel.reasonId;
        if (this.inputModel.reasonId) {
            this.selectedJobDescriptionInputs['reasonDisplayName'] = this.inputModel.reasonDisplayName;
        }
    };
    PutJobHoldWidgetComponent.prototype.resolveData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = true;
                        return [4 /*yield*/, this.holdReasonList()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PutJobHoldWidgetComponent.prototype.holdReasonList = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.commonService.getJobOnHoldDescription()
                .subscribe(function (resp) {
                _this.isLoading = false;
                //console.log(resp);
                _this.descriptionList = resp.map(function (item) {
                    return { id: item.Id, text: item.Description };
                });
                resolve();
            });
        });
    };
    PutJobHoldWidgetComponent.prototype.selectedDescription = function (event) {
        this.form.get('reasonId').setValue(event);
        if (event) {
            this.form.get('reasonDisplayName').setValue(this.getDisplayValue(event));
        }
    };
    PutJobHoldWidgetComponent.prototype.getDisplayValue = function (descId) {
        var selectedDescription = this.descriptionList.find(function (x) { return x.id == descId; });
        console.log(selectedDescription);
        return selectedDescription['text'];
    };
    PutJobHoldWidgetComponent.prototype.remove = function () {
        var blockObject = tslib_1.__assign({}, this.blockObject);
        blockObject.model = this.inputModel;
        this.close.emit({
            action: 'remove_block',
            data: blockObject
        });
    };
    PutJobHoldWidgetComponent.prototype.closeModal = function () {
        this.close.emit({
            action: 'close',
            data: null
        });
    };
    PutJobHoldWidgetComponent.prototype.save = function () {
        this.isFormSubmitted = true;
        var blockObject = tslib_1.__assign({}, this.blockObject);
        blockObject.model = new PutJobOnHoldBlockModel(this.form.value);
        var condition = this.form.value.condition;
        if (this.isConditional) {
            blockObject['condition'] = condition;
            blockObject['isConditional'] = true;
        }
        this.close.emit({
            action: 'save_and_close',
            data: blockObject
        });
    };
    return PutJobHoldWidgetComponent;
}());
export { PutJobHoldWidgetComponent };
